import http from './http'

/*
 * Die Vorlage der Einverständniserklärung öffnen (Anforderung #182).
 *
 * Zwei Stellen bieten sie an: die Schüler:in im eigenen Profil (Reiter
 * „Dokumente", ausgefüllt mit dem eigenen Namen) und die Lehrkraft im eigenen
 * Profil, je betreuter Junior Company (ohne Namen). Beide bekommen dieselbe
 * Vorlage vom Server — hier steht nur, wie das PDF geöffnet wird, damit der
 * Knopf an beiden Stellen dasselbe tut. Die Adressen:
 * `TApi.STUDENT_PARENTAL_CONFIRMATION_TEMPLATE` und
 * `TApi.TEACHER_PARENTAL_CONFIRMATION_TEMPLATE(companyId)`.
 */

export const openParentalTemplate = url =>
	http
		.get(url, {
			headers: {
				'Content-Type': 'application/pdf,image/jpeg,image/png,image/gif'
			},
			responseType: 'blob'
		})
		.then(({ data }) => {
			const file = new Blob([data], { type: data.type })
			const fileURL = URL.createObjectURL(file)
			window.open(fileURL)
		})
